// Copyright 2010 Jim Radford <radford@greenfelt.net> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile,
                              in_suit_order=piles.in_suit_order, score_run=piles.score_run,
                              up=piles.up, king=piles.king, ace=piles.ace;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE, GAME_OVER=seed_game.GAME_OVER;
var options = require('./options'), option_def=options.option_def;
var prnt = require('./print'), sprintf=prnt.sprintf, printf=prnt.printf;
var lib = require('./lib'), map=lib.map, srand=lib.srand, randseed=lib.randseed, shuffle_perfect=lib.shuffle_perfect;

solitaire.gaps = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.row = [];
        for (var r=0; r<4; r++) {
            this.row[r] = [];
            for (var c=0; c<13; c++) {
                this.row[r][c] = new this.segment("row"+(r+1)+"-"+(c+1), this, r, c);
                if (c) this.row[r][c-1].next = this.row[r][c];
                if (c) this.row[r][c].prev = this.row[r][c-1];
            }
        }
    }
    static variants = { addiction: { redeals: 3 } };

    valid_options = { redeals: option_def("number", 2, "Number of redeals allowed"),
                      easy:    option_def("boolean", false, "After a redeal leave gaps after the in-sequence cards instead of randomly"),
                      undo:    option_def("boolean", false, "allow undo past a redeal") };

    segment = class extends pile {
        constructor(div,game, r, c) {
                super(div,game);
                this.r = r;
                this.c = c;
        }
        _accept(card) { return card && (this.prev ? this.prev.pile[0] && in_suit_order(this.prev.pile[0],card) : card.rank == 2) }
        is_gap() { return this.pile.length == 0; }
        accept(card) { return this.is_gap() && this._accept(card) }
        can_drag(index) { return true; }
        onclick() {
                    if (!this.is_gap())
                        return false; // let the normal click handler handle it
                    var sources = this.game.filter_piles(function(curr) { return this._accept(curr.pile[0]) /*legit*/ &&
                                                                                 !(curr.c == 0 && curr.pile[0].rank == 2) /*!pointless*/ }, this);
                    if (sources[0]) {
                        this.game.push_state();
                        sources[0].move_to_pile(0,1,this);
                    }
        }
    };

    deal(deck) {
            this.update_redeals(this.options.redeals);
            for (var c=0; c<52; c++) {
                deck[c].face = up;
                if (deck[c].rank != ace)
                    this.row[Math.floor(c/13)][c%13].push(deck[c]);
            }
    }

    // Only need to save the number of redeals if we allow undoing past a redeal
    get_state() {
            var state = pile_game.prototype.get_state.call(this);
            state.redeals = this.redeals;
            return state;
    }

    set_state(old, noupdate) {
            pile_game.prototype.set_state.call(this, old, noupdate);
            this.update_redeals(old.redeals);
    }

    filter_piles(pred, _this) {
            var piles = [];
            for (var r=0; r<4; r++)
                for (var curr=this.row[r][0]; curr; curr=curr.next)
                    if (pred.call(_this, curr))
                        piles.push(curr);
            return piles;
    }

    first_incomplete(r) {
            for (var curr=this.row[r][0]; curr; curr=curr.next)
                if (!(curr._accept(curr.pile[0]) && curr.pile[0].rank == curr.c + 2))
                    break;
            return curr;
    }

    redeal() {
            var source_moves = [], destinations = [];
            for (var r=0; r<4; r++) {
                for (var first=this.first_incomplete(r), curr=first; curr; curr=curr.next) {
                    if (!curr.is_gap())
                        source_moves.push({ from: curr, fstart: 0, n: 1,
                                            // do the first half (the removal) of the move by hand
                                            tstart: 0, removed: [curr.pop()] });
                    if (!this.options.easy || first != curr)
                        destinations.push(curr);
                }
            }
            this.moves.push("*["+randseed()+"]");
            shuffle_perfect(destinations);

            if (!this.options.easy)
                destinations.splice(destinations.length-4,4);

            if (source_moves.length != destinations.length)
                printf("internal error %d != %d\n",source_moves.length, destinations.length);

            for (var i in source_moves) {
                source_moves[i].to = destinations[i];

                // Do this by hand instead of using do_move to avoid recording
                // the moves using add_move since they don't make sense
                // individually and all need to happen at once.
                destinations[i].push(source_moves[i].removed[0]);
            }
            this.animate_move(source_moves);
            this.end_of_move();
    }

    update_redeals(redeals) {
            this.shuffle_button.text(sprintf("Shuffle (%d)", this.redeals = redeals));
            this.shuffle_button.enable(this.redeals > 0);
    }

    shuffle() {
            if (this.redeals <= 0)
                return;
            if (!this.options.undo)
                this.clear_state(); // disallow undo through a redeal
            else
                this.push_state(); // support undoing redeals
            this.update_redeals(this.redeals - 1);
            this.redeal();
    }

    fix_replay_move(moves) {
            // If this move causes a shuffle then temporarily disable the shuffle that gets called in is_complete(). We'll do it manually as the next move.
            this.replay_dont_shuffle = !!moves.match(/^..\*/);
            // interpret the *[__random_seed] notation--reset the random seed and shuffle
            return moves.replace(/^\*\[(\d+)\]/, function(m, r) { srand(r); this.shuffle(); return "" }.bind(this));
    }

    is_complete_and_score() {
            var complete = WON, stuck = 0, score = 0, ordered = 0;
            for (var r=0; r<4; r++) {
                for (var first=this.first_incomplete(r), curr=first.next/*first cannot be stuck*/; curr; curr=curr.next)
                    if (curr.is_gap() && (curr.prev.is_gap() || curr.prev.pile[0].rank == king))
                        stuck++;
                var row_run = first.c + (!first.next && first.is_gap());
                if (row_run != 13)
                    complete = NOT_COMPLETE;
                else
                    stuck++; // Seems weird, but there *is* a gap there and you can't put anything in it.
                ordered += row_run;
                score += score_run(row_run);
            }
            return { complete: complete, stuck: stuck, score: score };
    }

    is_complete() {
            var cs = this.is_complete_and_score(), score=cs.score, stuck=cs.stuck, complete=cs.complete;
            if (stuck == 4 && complete != WON && !this.replay_dont_shuffle)
                if (this.redeals == 0)
                    complete = GAME_OVER;
                else
                    this.shuffle();
            return complete;
    }
    score() {
            return this.is_complete_and_score().score;
    }

    complete_not_yet() {
            var gaps = this.filter_piles(function(curr) { return curr.is_gap() }), any = 0;
            for (var i in gaps) {
                var fill_gap = function(gap) {
                    var sources = this.filter_piles(function(curr) { return gap._accept(curr.pile[0]) });
                    if (sources.length == 1) { // a clear choice
                        sources[0].move_to_pile(0, 1, gap, function() { fill_gap(sources[0]); });
                        any++;
                    }
                }.bind(this);
                fill_gap(gaps[i]);
            }
            return any;
    }

    layout = grid.apply(this, map(function (r) {
                                      return map(function (c) {
                                          return "row"+r+"-"+c;
                                      }, [1,2,3,4,5,6,7,8,9,10,11,12,13]);
                                  }, [1,2,3,4]));
}

module.exports = solitaire.gaps;
// Copyright 2010 Jim Radford <radford@greenfelt.net> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile,
                              in_suit_order=piles.in_suit_order, score_run=piles.score_run,
                              up=piles.up, king=piles.king, ace=piles.ace;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE, GAME_OVER=seed_game.GAME_OVER;
var options = require('./options'), option_def=options.option_def;
var prnt = require('./print'), sprintf=prnt.sprintf, printf=prnt.printf;
var lib = require('./lib'), map=lib.map, srand=lib.srand, randseed=lib.randseed, shuffle_perfect=lib.shuffle_perfect;

solitaire.gaps = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.row = [];
        for (var r=0; r<4; r++) {
            this.row[r] = [];
            for (var c=0; c<13; c++) {
                this.row[r][c] = new this.segment("row"+(r+1)+"-"+(c+1), this, r, c);
                if (c) this.row[r][c-1].next = this.row[r][c];
                if (c) this.row[r][c].prev = this.row[r][c-1];
            }
        }
    }
    static variants = { addiction: { redeals: 3 } };

    valid_options = { redeals: option_def("number", 2, "Number of redeals allowed"),
                      easy:    option_def("boolean", false, "After a redeal leave gaps after the in-sequence cards instead of randomly"),
                      undo:    option_def("boolean", false, "allow undo past a redeal") };

    segment = class extends pile {
        constructor(div,game, r, c) {
                super(div,game);
                this.r = r;
                this.c = c;
        }
        _accept(card) { return card && (this.prev ? this.prev.pile[0] && in_suit_order(this.prev.pile[0],card) : card.rank == 2) }
        is_gap() { return this.pile.length == 0; }
        accept(card) { return this.is_gap() && this._accept(card) }
        can_drag(index) { return true; }
        onclick() {
                    if (!this.is_gap())
                        return false; // let the normal click handler handle it
                    var sources = this.game.filter_piles(function(curr) { return this._accept(curr.pile[0]) /*legit*/ &&
                                                                                 !(curr.c == 0 && curr.pile[0].rank == 2) /*!pointless*/ }, this);
                    if (sources[0]) {
                        this.game.push_state();
                        sources[0].move_to_pile(0,1,this);
                    }
        }
    };

    deal(deck) {
            this.update_redeals(this.options.redeals);
            for (var c=0; c<52; c++) {
                deck[c].face = up;
                if (deck[c].rank != ace)
                    this.row[Math.floor(c/13)][c%13].push(deck[c]);
            }
    }

    // Only need to save the number of redeals if we allow undoing past a redeal
    get_state() {
            var state = pile_game.prototype.get_state.call(this);
            state.redeals = this.redeals;
            return state;
    }

    set_state(old, noupdate) {
            pile_game.prototype.set_state.call(this, old, noupdate);
            this.update_redeals(old.redeals);
    }

    filter_piles(pred, _this) {
            var piles = [];
            for (var r=0; r<4; r++)
                for (var curr=this.row[r][0]; curr; curr=curr.next)
                    if (pred.call(_this, curr))
                        piles.push(curr);
            return piles;
    }

    first_incomplete(r) {
            for (var curr=this.row[r][0]; curr; curr=curr.next)
                if (!(curr._accept(curr.pile[0]) && curr.pile[0].rank == curr.c + 2))
                    break;
            return curr;
    }

    redeal() {
            var source_moves = [], destinations = [];
            for (var r=0; r<4; r++) {
                for (var first=this.first_incomplete(r), curr=first; curr; curr=curr.next) {
                    if (!curr.is_gap())
                        source_moves.push({ from: curr, fstart: 0, n: 1,
                                            // do the first half (the removal) of the move by hand
                                            tstart: 0, removed: [curr.pop()] });
                    if (!this.options.easy || first != curr)
                        destinations.push(curr);
                }
            }
            this.moves.push("*["+randseed()+"]");
            shuffle_perfect(destinations);

            if (!this.options.easy)
                destinations.splice(destinations.length-4,4);

            if (source_moves.length != destinations.length)
                printf("internal error %d != %d\n",source_moves.length, destinations.length);

            for (var i in source_moves) {
                source_moves[i].to = destinations[i];

                // Do this by hand instead of using do_move to avoid recording
                // the moves using add_move since they don't make sense
                // individually and all need to happen at once.
                destinations[i].push(source_moves[i].removed[0]);
            }
            this.animate_move(source_moves);
            this.end_of_move();
    }

    update_redeals(redeals) {
            this.shuffle_button.text(sprintf("Shuffle (%d)", this.redeals = redeals));
            this.shuffle_button.enable(this.redeals > 0);
    }

    shuffle() {
            if (this.redeals <= 0)
                return;
            if (!this.options.undo)
                this.clear_state(); // disallow undo through a redeal
            else
                this.push_state(); // support undoing redeals
            this.update_redeals(this.redeals - 1);
            this.redeal();
    }

    fix_replay_move(moves) {
            // If this move causes a shuffle then temporarily disable the shuffle that gets called in is_complete(). We'll do it manually as the next move.
            this.replay_dont_shuffle = !!moves.match(/^..\*/);
            // interpret the *[__random_seed] notation--reset the random seed and shuffle
            return moves.replace(/^\*\[(\d+)\]/, function(m, r) { srand(r); this.shuffle(); return "" }.bind(this));
    }

    is_complete_and_score() {
            var complete = WON, stuck = 0, score = 0, ordered = 0;
            for (var r=0; r<4; r++) {
                for (var first=this.first_incomplete(r), curr=first.next/*first cannot be stuck*/; curr; curr=curr.next)
                    if (curr.is_gap() && (curr.prev.is_gap() || curr.prev.pile[0].rank == king))
                        stuck++;
                var row_run = first.c + (!first.next && first.is_gap());
                if (row_run != 13)
                    complete = NOT_COMPLETE;
                else
                    stuck++; // Seems weird, but there *is* a gap there and you can't put anything in it.
                ordered += row_run;
                score += score_run(row_run);
            }
            return { complete: complete, stuck: stuck, score: score };
    }

    is_complete() {
            var cs = this.is_complete_and_score(), score=cs.score, stuck=cs.stuck, complete=cs.complete;
            if (stuck == 4 && complete != WON && !this.replay_dont_shuffle)
                if (this.redeals == 0)
                    complete = GAME_OVER;
                else
                    this.shuffle();
            return complete;
    }
    score() {
            return this.is_complete_and_score().score;
    }

    complete_not_yet() {
            var gaps = this.filter_piles(function(curr) { return curr.is_gap() }), any = 0;
            for (var i in gaps) {
                var fill_gap = function(gap) {
                    var sources = this.filter_piles(function(curr) { return gap._accept(curr.pile[0]) });
                    if (sources.length == 1) { // a clear choice
                        sources[0].move_to_pile(0, 1, gap, function() { fill_gap(sources[0]); });
                        any++;
                    }
                }.bind(this);
                fill_gap(gaps[i]);
            }
            return any;
    }

    layout = grid.apply(this, map(function (r) {
                                      return map(function (c) {
                                          return "row"+r+"-"+c;
                                      }, [1,2,3,4,5,6,7,8,9,10,11,12,13]);
                                  }, [1,2,3,4]));
}

module.exports = solitaire.gaps;
